var products = {
    SET_PAY: "INSTALLMENT_LOAN",
};
export default products;
